<template>
  <div v-if="selection" class='selection-component' :class="{'team-logos': teamLogoVisibility}"
       :idfoselection="(selection && selection.idfoselection && selection.idfoselection.toString()) || 'null'">
    <div v-if="showselectionname" class="selectionname">
      <span v-if="showparticipantlogo" class="team-logo" :style="teamLogoStyle"></span>
      <span class="text-overflow">{{ selection.name }}</span>
      <span v-if="isoutright && showParticipantStats && participantWins && participantLosses" class="stats">
        {{participantWins}} - {{participantLosses}}
        <span v-if="participantTies">&nbsp;- {{ participantTies }}</span>
        <span v-if="participantOvertimeLosses">&nbsp;- {{ participantOvertimeLosses }}</span>
      </span>
    </div>
    <div v-if="showshortselectionname" class="selectionname">
      <span v-if="showparticipantlogo" class="team-logo" :style="teamLogoStyle"></span>
      <span class="text-overflow">{{ selection.shortname }}</span>
      <span v-if="isoutright && showParticipantStats && participantWins && participantLosses" class="stats">
        {{participantWins}} - {{participantLosses}}
        <span v-if="participantTies">&nbsp;- {{ participantTies }}</span>
        <span v-if="participantOvertimeLosses">&nbsp;- {{ participantOvertimeLosses }}</span>
      </span>
    </div>
    <div class="selectionlistcode" ><span class="text-overflow">{{ selection.listcode || '-' }}</span></div>

    <div class="value" :class="[{ 'show-one-in-one-line': showOneInOneLine },
      { 'suspended': !istradable || selection.idfobolifestate === 'NR' || selection.idfoselectionsuspensiontype }, priceChange]">

      <div v-if="istradable && selection.idfobolifestate !== 'NR' && !selection.idfoselectionsuspensiontype"
           class="selectionprice"
           :class="{
              noprice: !formatedSelectionPrice,
              'with-handicap': currentMatchHandicap|| (currentMatchHandicap === 0 && ['H', 'D', 'A'].indexOf(selection.hadvalue) > -1),
              longprice: (formatedSelectionPrice && (formatedSelectionPrice.length > selectionLength)) }">

        <span v-if="currentMatchHandicap|| (currentMatchHandicap === 0 && ['H', 'D', 'A'].indexOf(selection.hadvalue) > -1)" class="currenthandicap">
          <div v-if="['O', 'U'].indexOf(selection.hadvalue) > -1" class="had-value">
            <span v-if="selection.hadvalue == 'O'">
              <span v-if="brand_translux1">O</span>
              <span v-else>Ov</span>
            </span>
            <span v-if="selection.hadvalue == 'U'">
              <span v-if="brand_translux1">U</span>
              <span v-else>Un</span>
            </span>
          </div>
          <div v-if="['O', 'U'].indexOf(selection.hadvalue) > -1" class="uo-currenthandicap">{{ currentMatchHandicap }}</div>
          <div v-if="['H', 'D'].indexOf(selection.hadvalue) > -1">
            <template v-if="currentMatchHandicap !== 0">{{ currentMatchHandicap > 0 ? `+${currentMatchHandicap}` : `${currentMatchHandicap}` }}</template>
            <template v-else>PK</template>
          </div>
          <div v-if="['A'].indexOf(selection.hadvalue) > -1">
            <template v-if="currentMatchHandicap !== 0">{{ (currentMatchHandicap * -1) > 0 ? `+${currentMatchHandicap * -1}` : `${currentMatchHandicap * -1}` }}</template>
            <template v-else>PK</template>
          </div>
        </span>

        <span v-if="brand_translux1" class="price" >
          <span >{{ formatedSelectionPrice || '--' }}</span>
        </span>
        <span v-else class="price">
          {{ formatedSelectionPrice || '--' }}
        </span>
      </div>
      <div v-else class="selectionprice suspended"><icon name="icon-lock" :colorName="brand_translux4 || brand_translux3 || brand_translux2 || brand_translux1 || brand_translux ? 'white' : 'dark'"></icon></div>
    </div>
  </div>
</template>
<script>
  import config from '@/config'
  import Icon from '@/components/common/Icon'
  import Brands from '@/components/mixins/Brands'
  import UrlParameters from '@/components/mixins/UrlParameters'
  import TeamLogo from '@/components/mixins/TeamLogo'
  import ParticipantInfos from '@/components/mixins/ParticipantInfos'

  export default {
    name: 'market-selection',
    components: {
      Icon
    },
    mixins: [
      Brands,
      TeamLogo,
      ParticipantInfos,
      UrlParameters
    ],
    props: [
      'event',
      'selection',
      'istradable',
      'showselectionname',
      'showshortselectionname',
      'ishad',
      'isoutright',
      'showOneInOneLine',
      'fosportname'
    ],

    data () {
      return {
        oldPrice: 0,
        priceChange: '',
        selectionChangeTimeout: 0,
        selectionLength: 5,
        secondselectionLength: 8
      }
    },

    computed: {
      teamLogos () {
        return {
          logo: this.selection && (this.selection.logo || this.selection.participlogo)
        }
      },
      formatedSelectionPrice () {
        var selection = this.selection

        this.processSelectionPriceChange()

        if (!isNaN(parseFloat(selection.currentpriceup)) && !isNaN(parseFloat(selection.currentpricedown))) {
          let price = 1 + selection.currentpriceup / selection.currentpricedown
          let priceus = 0
          let sign = ''

          if (config.app.priceFormat === 'US') {
            if (price >= 2) {
              priceus = 100 * (price - 1)
              sign = '+'
            } else {
              priceus = -100 / (price - 1)
              sign = ''
            }

            return priceus.toFixed(0) === '100' ? 'Even' : sign + priceus.toFixed(0)
          } else {
            return price.toFixed(2)
          }
        } else {
          return undefined
        }
      },
      currentMatchHandicap () {
        return this.selection.currenthandicap || this.selection.currentmatchhandicap
      }
    },

    methods: {
      processSelectionPriceChange () {
        var self = this

        if (this.selection) {
          if (this.oldPrice) {
            if (this.selection.price && this.selection.price !== this.oldPrice) {
              if (this.selection.price > this.oldPrice) {
                this.priceChange = 'priceup'
              } else if (this.selection.price < this.oldPrice) {
                this.priceChange = 'pricedown'
              }

              clearTimeout(this.selectionChangeTimeout)

              this.selectionChangeTimeout = setTimeout(() => {
                self.priceChange = ''
              }, 3000)
            }
          }

          this.oldPrice = this.selection.price
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .selection-component
    .value.priceup
    .value.pricedown
      color: #fff

    .value.pricedown
      .selectionprice
        background-color #e83f3f

    .value.priceup
      .selectionprice
        background-color #29ab29

    .selectionname
      text-align center
      padding 0 5px
      height: 35px
      font-size: 1.2rem
      text-transform: uppercase

      .outright-market &
        text-transform: none

    .selectionprice
      text-align center
      font-size 2rem
      font-weight: bold
      background: #fff
      display: flex
      align-items: center
      justify-content: center
      transition: all 1s

      &.longprice
        font-size 1.7rem

  .currenthandicap
    font-size 1.5rem
</style>



// WEBPACK FOOTER //
// src/components/bettingoffer/selection.vue